import { PosterParallaxClass } from './PosterParallax.js'
import App from '../stores/app.js'

export default window.customElements.define(
  'video-parallax',
  class extends PosterParallaxClass {
    constructor() {
      super()

      this.events = {
        ...this.events,
        'click .js-video-parallax-play': 'onClickPlay',
        'click .js-video-parallax-dialog-close-btn': 'onClickClose'
      }
    }

    connectedCallback() {
      super.connectedCallback()
      this.$videoPlaceholder = this.querySelector(
        '.js-video-parallax-video-placeholder'
      )
      this.$dialog = this.querySelector('dialog')
      this.template = this.querySelector('.js-video-parallax-template').content

      if (this.$dialog) {
        this._onCloseDialog = this.onCloseDialog.bind(this)
        this.$dialog.addEventListener('close', this._onCloseDialog)
      } else {
        this.injectVideo()
      }
    }

    disconnectedCallback() {
      super.disconnectedCallback()
    }

    injectVideo(play) {
      setTimeout(() => {
        this.$videoPlaceholder &&
          this.$videoPlaceholder.replaceWith(this.template)
        this.$video = this.querySelector('video')
        play && this.$video.play()
      }, 300)
    }

    onClickPlay(e) {
      e.preventDefault()

      this.setData({ playing: true })

      !this.dataset.dialog && this.onMouseLeave()

      if (this.dataset.dialog && this.$dialog) {
        this.injectVideo(true)

        App.lenis.stop()
        this.$dialog.showModal()
        setTimeout(() => {
          this.$dialog.classList.add('is-active')
        }, 10)
      } else {
        this.$video = this.querySelector('video')
        this.$video.play()
      }
    }

    onMouseEnter() {
      // only mouse enter again if not playing
      !this.playing && super.onMouseEnter()
    }

    onClickClose() {
      this.$dialog.classList.remove('is-active')
      setTimeout(() => {
        this.$dialog.close()
      }, 900)
    }

    onCloseDialog() {
      App.lenis.start()
      this.setData({ playing: false })
      this.$dialog.querySelector('plyr-video').pause()
    }
  }
)
